import React, { useEffect, useState, useRef, createElement } from 'react';
import { CheckCircle2, Lock, User, Mail, Phone, Globe, X, ArrowRight, Clock, TrendingUp, DollarSign, Zap, Target, Users, Video, Calendar, Ticket, Search, Bot, MessageSquare, Mic, Quote, AlertTriangle, ShieldCheck, Car, Briefcase, HelpCircle, Frown, Sparkles, XCircle, Monitor } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
  }
}
const COUNTRY_CODES = [{
  code: '+1',
  country: 'USA/Canada'
}, {
  code: '+52',
  country: 'México'
}, {
  code: '+57',
  country: 'Colombia'
}, {
  code: '+34',
  country: 'España'
}, {
  code: '+54',
  country: 'Argentina'
}, {
  code: '+56',
  country: 'Chile'
}, {
  code: '+51',
  country: 'Perú'
}, {
  code: '+593',
  country: 'Ecuador'
}, {
  code: '+58',
  country: 'Venezuela'
}, {
  code: '+502',
  country: 'Guatemala'
}, {
  code: '+503',
  country: 'El Salvador'
}, {
  code: '+504',
  country: 'Honduras'
}, {
  code: '+505',
  country: 'Nicaragua'
}, {
  code: '+506',
  country: 'Costa Rica'
}, {
  code: '+507',
  country: 'Panamá'
}, {
  code: '+591',
  country: 'Bolivia'
}, {
  code: '+595',
  country: 'Paraguay'
}, {
  code: '+598',
  country: 'Uruguay'
}, {
  code: '+1-809',
  country: 'Rep. Dominicana'
}];
// Get next Thursday 7PM Miami (EST) as Date object
const getNextThursdayDate = () => {
  const now = new Date();
  const estTime = new Date(now.toLocaleString('en-US', {
    timeZone: 'America/New_York'
  }));
  const currentDay = estTime.getDay();
  const currentHour = estTime.getHours();
  let daysUntilThursday = 0;
  if (currentDay === 4) {
    daysUntilThursday = currentHour >= 19 ? 7 : 0;
  } else if (currentDay < 4) {
    daysUntilThursday = 4 - currentDay;
  } else {
    daysUntilThursday = 7 - currentDay + 4;
  }
  const next = new Date(estTime);
  next.setDate(estTime.getDate() + daysUntilThursday);
  next.setHours(19, 0, 0, 0);
  // Convert back to actual moment (the est-string trick gave us a "wall clock" date in EST)
  // For the countdown we need actual ms remaining — use timezone offset correction
  const estOffsetMinutes = -new Date().toLocaleString('en-US', {
    timeZone: 'America/New_York',
    timeZoneName: 'short'
  }).includes('EDT') ? 240 : 300;
  // Simpler approach: compute target by anchoring to UTC
  const utcNow = new Date();
  // Find target date in EST then add EST offset
  // We'll compute the target by building an ISO string and parsing as if EST
  return next;
};
const getThursdayLabel = () => {
  const t = getNextThursdayDate();
  const day = t.getDate();
  const month = t.toLocaleString('es-ES', {
    month: 'long'
  }).toUpperCase();
  return `JUEVES ${day} DE ${month}`;
};
export function CarSalesmanWebinarPage() {
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [areaCode, setAreaCode] = useState('+1');
  const [phone, setPhone] = useState('');
  const [smsConsent, setSmsConsent] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [countdown, setCountdown] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const navigate = useNavigate();
  const nameRef = useRef<HTMLInputElement>(null);
  const emailRef = useRef<HTMLInputElement>(null);
  const phoneRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
    window.fbq('trackCustom', 'CarSalesman-WebinarView');
    // Countdown interval — re-anchor each tick using EST string
    const tick = () => {
      const nowMs = Date.now();
      // Build target: next Thursday at 7PM Miami in MS
      const estNow = new Date(new Date().toLocaleString('en-US', {
        timeZone: 'America/New_York'
      }));
      const currentDay = estNow.getDay();
      const currentHour = estNow.getHours();
      let daysUntil = 0;
      if (currentDay === 4) {
        daysUntil = currentHour >= 19 ? 7 : 0;
      } else if (currentDay < 4) {
        daysUntil = 4 - currentDay;
      } else {
        daysUntil = 7 - currentDay + 4;
      }
      const estTarget = new Date(estNow);
      estTarget.setDate(estNow.getDate() + daysUntil);
      estTarget.setHours(19, 0, 0, 0);
      // Compute diff in EST domain — both timestamps are constructed from EST wall clocks
      let diffMs = estTarget.getTime() - estNow.getTime();
      if (diffMs < 0) diffMs = 0;
      const days = Math.floor(diffMs / 86400000);
      const hours = Math.floor(diffMs % 86400000 / 3600000);
      const minutes = Math.floor(diffMs % 3600000 / 60000);
      const seconds = Math.floor(diffMs % 60000 / 1000);
      setCountdown({
        days,
        hours,
        minutes,
        seconds
      });
    };
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, []);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isSubmitting) return;
    const finalName = nameRef.current?.value?.trim() || name.trim();
    const finalEmail = emailRef.current?.value?.trim() || email.trim();
    const finalPhone = phoneRef.current?.value?.replace(/\D/g, '').trim() || phone.trim();
    if (!finalName || finalName.length < 2) {
      alert('Por favor ingresa tu nombre completo');
      return;
    }
    if (!finalEmail || !finalEmail.includes('@')) {
      alert('Por favor ingresa un email válido');
      return;
    }
    if (!finalPhone || finalPhone.length < 7) {
      alert('Por favor ingresa tu teléfono');
      return;
    }
    if (!smsConsent) {
      alert('Por favor marca la casilla de consentimiento de SMS para continuar.');
      return;
    }
    setIsSubmitting(true);
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', {
          content_name: 'Car Salesman Webinar Registration'
        });
      }
      const webhookUrl = 'https://services.leadconnectorhq.com/hooks/HMYR0XQcpZnIeoWD2nrn/webhook-trigger/9e77fbea-dfb7-4800-9398-1f4c8701198d';
      await fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: finalName,
          email: finalEmail,
          phone: `${areaCode}${finalPhone}`,
          first_name: finalName.split(' ')[0],
          last_name: finalName.split(' ').slice(1).join(' ') || finalName.split(' ')[0],
          full_name: finalName,
          fullPhone: `${areaCode}${finalPhone}`,
          areaCode: areaCode,
          source: '/car-salesman-webinar',
          page_path: '/car-salesman-webinar',
          tag: 'car-salesman-webinar',
          sms_consent: smsConsent,
          event_time: Math.floor(Date.now() / 1000),
          event_source_url: window.location.href,
          action_source: 'website'
        })
      });
      navigate('/thank-you');
    } catch (err) {
      console.error('Submit error:', err);
      navigate('/thank-you');
    } finally {
      setIsSubmitting(false);
    }
  };
  const painPoints = [{
    icon: Car,
    text: 'Las 70 horas semanales — sábados incluidos'
  }, {
    icon: DollarSign,
    text: 'La angustia de fin de mes — mes bueno vs mes malo'
  }, {
    icon: Frown,
    text: 'Los gerentes que ganan 3x más por hacer la mitad'
  }, {
    icon: Users,
    text: 'Perderte los partidos de tu hijo (otra vez)'
  }, {
    icon: TrendingUp,
    text: 'Las cuotas que suben cada año pero el sueldo no'
  }, {
    icon: Clock,
    text: 'La sensación de que sigues exactamente igual que hace 3 años'
  }];
  const blocks = [{
    icon: Search,
    label: 'Bloque 1',
    tag: 'Encontrar clientes',
    title: 'Cómo Encontrar 200 Clientes En 60 Segundos',
    desc: 'Voy a abrir LA HERRAMIENTA delante tuyo. En tiempo real. Vas a ver una lista de 200 dentistas / talleres / salones en CUALQUIER ciudad de USA — todos sin web. Listos para contactar.'
  }, {
    icon: Bot,
    label: 'Bloque 2',
    tag: 'Construir la web',
    title: 'Construyo Una Web Completa Delante Tuyo',
    desc: 'Sin código. Sin programación. En menos de 2 horas. Solo IA + supervisión + click. Vas a entender por qué cobramos $800–$1,500 por algo que toma 2 horas.'
  }, {
    icon: MessageSquare,
    label: 'Bloque 3',
    tag: 'Cerrar clientes',
    title: 'Los Mensajes Que Cierran',
    desc: 'Específicamente para vendedores de carros: cómo adaptas tu técnica de cierre del showroom a este nuevo contexto. Vas a ver pantallazos REALES de conversaciones donde un alumno cerró $1,200 con UN solo mensaje correcto.'
  }, {
    icon: Mic,
    label: 'Bloque 4',
    tag: 'Q&A',
    title: 'Q&A De 30 Minutos En Vivo',
    desc: 'Esto es lo que ningún video pre-grabado te puede dar. TÚ me preguntas. Sobre tu ciudad. Tu situación. Tus dudas. Te respondo en tiempo real.'
  }];
  const milestones = [{
    mes: 'Mes 1',
    value: '$3,600',
    note: '2 horas/día después del dealership'
  }, {
    mes: 'Mes 2',
    value: '$7,800',
    note: 'Primer cliente recurrente'
  }, {
    mes: 'Mes 3',
    value: '$11,500',
    note: 'Reemplazó su sueldo'
  }, {
    mes: 'Mes 4',
    value: '$14,200',
    note: 'RENUNCIÓ al dealership'
  }, {
    mes: 'Hoy (11 meses)',
    value: '$18K–$22K/mes',
    note: 'Promedio mensual',
    highlight: true
  }];
  const isFor = ['Eres vendedor de carros (o ex-vendedor con experiencia)', 'Vives en USA (cualquier estado)', 'Hablas español (o inglés básico)', 'Estás dispuesto a invertir 5–10 horas a la semana al modelo', 'Tienes mentalidad de EJECUTOR — no de "voy a pensarlo"', 'Estás cansado del schedule del dealership'];
  const notFor = ['Buscas un botón mágico que genere dinero sin esfuerzo', 'No tienes 5 horas a la semana', 'Eres "perpetuo aprendiz" que nunca ejecuta', 'Vienes solo a mirar webinars como entretenimiento'];
  const faqs = [{
    q: '¿Es para mí si NO soy vendedor de carros?',
    a: 'Es para CUALQUIER vendedor con experiencia previa: carros, seguros, bienes raíces, electrodomésticos. El webinar está optimizado para vendedores de carros porque son ideales — pero todos los que vendan algo, califican.'
  }, {
    q: '¿Tengo que tener mi cámara prendida?',
    a: 'NO. Es 100% asíncrono — puedes asistir desde el celular, con cámara apagada, hasta desde la cama. Solo necesitas estar conectado para no perderte la herramienta y el demo del software.'
  }, {
    q: '¿Habrá reposición si me lo pierdo?',
    a: 'NO. Es EN VIVO porque la herramienta y el demo no se pueden grabar (son en tiempo real). Si no puedes asistir el jueves, registrate igual — te aviso de los próximos webinars.'
  }, {
    q: '¿Cuánto cuesta el programa premium después?',
    a: 'Inversión inicial: $297. Acceso a todo el sistema, la comunidad, la herramienta de búsqueda, y soporte. Pero te lo explico AL FINAL del webinar con todos los detalles. No vienes a comprar — vienes a aprender.'
  }, {
    q: '¿50+ años? ¿Sigo a tiempo?',
    a: 'Mi mejor alumno del último trimestre tiene 58 años. Tu edad NO es factor. Tu experiencia EN VENTAS sí lo es. Si tienes 2+ años cerrando ventas, eres mejor candidato que un joven de 25 sin experiencia.'
  }];
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  const thursdayLabel = getThursdayLabel();
  return <div className="min-h-screen bg-[#0a1428] text-white font-sans selection:bg-amber-400 selection:text-[#0a1428] overflow-x-hidden" data-id="element-939">
      <noscript data-id="element-940">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-941" />
      </noscript>

      {/* Background Image Layer (same as /meta-jueves) */}
      <div className="absolute top-0 left-0 w-full h-[400px] md:h-[600px] z-0 opacity-60 pointer-events-none" data-id="element-942">
        <img src="https://cdn.magicpatterns.com/uploads/owSR6X5Pw8KuRfkif7sGzk/6936d7f7169a421d1ba8a294.png" alt="Background Pattern" className="w-full h-full object-cover" style={{
        maskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)',
        WebkitMaskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)'
      }} data-id="element-943" />
      </div>

      {/* Ambient glows */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[600px] bg-amber-500/[0.08] blur-[140px] rounded-full pointer-events-none" data-id="element-944" />
      <div className="absolute top-[40%] right-0 w-[500px] h-[500px] bg-amber-400/[0.04] blur-[120px] rounded-full pointer-events-none" data-id="element-945" />
      <div className="absolute top-[10%] left-0 w-[400px] h-[400px] bg-blue-500/[0.04] blur-[120px] rounded-full pointer-events-none" data-id="element-946" />

      <div className="absolute inset-0 opacity-[0.015] pointer-events-none" style={{
      backgroundImage: 'linear-gradient(rgba(255,255,255,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.4) 1px, transparent 1px)',
      backgroundSize: '60px 60px'
    }} data-id="element-947" />

      {/* ============ FLOATING HEADER ============ */}
      <header className="fixed top-3 md:top-5 left-0 right-0 z-50 px-3 md:px-6 pointer-events-none" data-id="element-948">
        <div className="max-w-5xl mx-auto pointer-events-auto" data-id="element-949">
          <div className="relative bg-[#0f1b35]/80 backdrop-blur-xl border border-amber-500/25 rounded-full shadow-[0_10px_40px_-10px_rgba(0,0,0,0.6),0_0_30px_-10px_rgba(245,158,11,0.3)]" data-id="element-950">
            <div className="flex items-center justify-between gap-3 pl-3 pr-2 md:pl-5 md:pr-2.5 py-2 md:py-2.5" data-id="element-951">
              <div className="flex items-center gap-2.5 min-w-0" data-id="element-952">
                <div className="flex items-center justify-center w-8 h-8 md:w-9 md:h-9 rounded-full bg-amber-500/15 border border-amber-500/40 flex-shrink-0" data-id="element-953">
                  <Video className="w-4 h-4 md:w-[18px] md:h-[18px] text-amber-400" data-id="element-954" />
                </div>
                <div className="flex flex-col leading-none min-w-0" data-id="element-955">
                  <span className="text-amber-400 text-[9px] md:text-[10px] font-black uppercase tracking-[0.18em] leading-none" data-id="element-956">
                    Webinar Gratuito
                  </span>
                  <span className="text-white text-xs md:text-sm font-black tracking-tight mt-1 truncate" data-id="element-957">
                    Escapa del Dealership
                  </span>
                </div>
              </div>

              <div className="hidden lg:flex items-center gap-2 px-3" data-id="element-958">
                <Calendar className="w-3.5 h-3.5 text-amber-400/70 flex-shrink-0" data-id="element-959" />
                <span className="text-gray-300 text-xs font-bold uppercase tracking-[0.12em] leading-none whitespace-nowrap" data-id="element-960">
                  {thursdayLabel}
                </span>
                <span className="inline-block w-px h-3.5 bg-amber-500/25" data-id="element-961" />
                <Clock className="w-3.5 h-3.5 text-amber-400/70 flex-shrink-0" data-id="element-962" />
                <span className="text-gray-300 text-xs font-bold uppercase tracking-[0.12em] leading-none whitespace-nowrap" data-id="element-963">
                  7PM EST
                </span>
              </div>

              <button type="button" onClick={() => setShowModal(true)} className="group flex items-center gap-1.5 md:gap-2 bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-[10px] md:text-xs uppercase tracking-tight rounded-full px-3.5 md:px-5 py-2 md:py-2.5 shadow-[0_8px_25px_-8px_rgba(245,158,11,0.6)] hover:shadow-[0_8px_25px_-5px_rgba(245,158,11,0.8)] transition-all duration-300 flex-shrink-0 whitespace-nowrap" data-id="element-964">
                <Ticket className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-965" />
                <span className="hidden sm:inline" data-id="element-966">Reservar Cupo</span>
                <span className="sm:hidden" data-id="element-967">Reservar</span>
                <ArrowRight className="w-3.5 h-3.5 md:w-4 md:h-4 transition-transform group-hover:translate-x-0.5" data-id="element-968" />
              </button>
            </div>
          </div>
        </div>
      </header>

      <main className="relative z-10 max-w-7xl mx-auto px-4 lg:px-8 pt-20 md:pt-24 lg:pt-20 pb-12" data-id="element-969">
        {/* ============ HERO ============ */}
        <section className="mb-16 md:mb-20 lg:mb-28 text-center" data-id="element-970">
          <div className="inline-flex items-center gap-2 bg-red-500/10 border border-red-500/30 rounded-full px-3.5 py-1.5 mb-6 md:mb-8" data-id="element-971">
            <span className="relative flex h-2 w-2" data-id="element-972">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" data-id="element-973" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500" data-id="element-974" />
            </span>
            <span className="text-red-400 text-[10px] md:text-xs font-black uppercase tracking-[0.18em] leading-none" data-id="element-975">
              Masterclass en Vivo
            </span>
          </div>

          {/* Hero visual — moved above headline */}
          <div className="relative flex justify-center mb-6 md:mb-8 lg:mb-10" data-id="element-976">
            <div className="relative w-full max-w-2xl lg:max-w-4xl xl:max-w-5xl" data-id="element-977">
              <div className="hidden md:flex absolute top-4 lg:top-8 left-0 lg:-left-4 xl:-left-10 z-20 bg-[#0f1b35]/95 backdrop-blur-sm border border-amber-500/30 rounded-2xl px-4 py-3 lg:px-5 lg:py-4 shadow-2xl rotate-[-6deg] hover:rotate-0 transition-transform duration-500" data-id="element-978">
                <div className="flex items-center gap-2.5 lg:gap-3" data-id="element-979">
                  <div className="w-9 h-9 lg:w-11 lg:h-11 rounded-xl bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center" data-id="element-980">
                    <TrendingUp className="w-4 h-4 lg:w-5 lg:h-5 text-emerald-400" data-id="element-981" />
                  </div>
                  <div className="text-left" data-id="element-982">
                    <div className="text-[10px] lg:text-[11px] text-gray-400 uppercase tracking-wider font-bold" data-id="element-983">
                      Ingreso meta
                    </div>
                    <div className="text-sm lg:text-base font-black text-white" data-id="element-984">
                      $10K–$20K/mes
                    </div>
                  </div>
                </div>
              </div>

              <div className="hidden md:flex absolute bottom-4 lg:bottom-8 right-0 lg:-right-4 xl:-right-10 z-20 bg-[#0f1b35]/95 backdrop-blur-sm border border-amber-500/30 rounded-2xl px-4 py-3 lg:px-5 lg:py-4 shadow-2xl rotate-[5deg] hover:rotate-0 transition-transform duration-500" data-id="element-985">
                <div className="flex items-center gap-2.5 lg:gap-3" data-id="element-986">
                  <div className="w-9 h-9 lg:w-11 lg:h-11 rounded-xl bg-amber-500/15 border border-amber-500/30 flex items-center justify-center" data-id="element-987">
                    <Video className="w-4 h-4 lg:w-5 lg:h-5 text-amber-400" data-id="element-988" />
                  </div>
                  <div className="text-left" data-id="element-989">
                    <div className="text-[10px] lg:text-[11px] text-gray-400 uppercase tracking-wider font-bold" data-id="element-990">
                      Duración
                    </div>
                    <div className="text-sm lg:text-base font-black text-white" data-id="element-991">
                      90 minutos
                    </div>
                  </div>
                </div>
              </div>

              <div className="absolute inset-0 bg-black/70 blur-[120px] lg:blur-[160px] rounded-full scale-90 pointer-events-none" data-id="element-992" />

              <img src="https://cdn.magicpatterns.com/uploads/4WKjQ8RUKi5FvD9kSojqRR/Banner_Transparente_AI_WEB_CLOSER.png" alt="Gabriel Beltrán AI Web Closer Masterclass Live" className="relative w-full h-auto drop-shadow-2xl animate-fade-in-up" data-id="element-993" />
            </div>
          </div>

          <h1 className="text-[2rem] md:text-5xl lg:text-[4.5rem] xl:text-[5rem] font-black leading-[1.02] tracking-tight mb-5 md:mb-6 lg:mb-7 max-w-5xl mx-auto" data-id="element-994">
            Escapa del Dealership y{' '}
            <span className="relative inline-block" data-id="element-995">
              <span className="relative z-10 text-amber-400" data-id="element-996">
                Genera $10K–$20K
              </span>
              <span className="absolute bottom-1 left-0 w-full h-3 bg-amber-400/15 -z-0 rounded-sm" data-id="element-997" />
            </span>{' '}
            al Mes Desde Casa
          </h1>

          <div className="inline-flex flex-wrap items-center justify-center gap-2 md:gap-3 bg-white/[0.03] border border-amber-500/20 rounded-full px-4 md:px-5 py-2 md:py-2.5 mb-8 md:mb-10" data-id="element-998">
            <Calendar className="w-4 h-4 text-amber-400" data-id="element-999" />
            <span className="text-amber-400 text-sm md:text-base font-black uppercase tracking-tight" data-id="element-1000">
              {thursdayLabel}
            </span>
            <span className="w-px h-4 bg-amber-500/30" data-id="element-1001" />
            <Clock className="w-4 h-4 text-amber-400" data-id="element-1002" />
            <span className="text-amber-400 text-sm md:text-base font-black uppercase tracking-tight" data-id="element-1003">
              7PM EST · Hora Miami
            </span>
          </div>

          {/* Mobile-only CTA — placed directly under the date badge */}
          <div className="md:hidden max-w-md mx-auto mb-8" data-id="element-1004">
            <button type="button" onClick={() => setShowModal(true)} className="group relative w-full bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-base uppercase tracking-tight rounded-2xl py-5 px-6 shadow-[0_20px_60px_-15px_rgba(245,158,11,0.6)] transition-all duration-300 transform hover:scale-[1.02] overflow-hidden" data-id="element-1005">
              <span className="relative z-10 flex flex-col items-center gap-1" data-id="element-1006">
                <span className="flex items-center justify-center gap-2.5" data-id="element-1007">
                  <Ticket className="w-5 h-5" data-id="element-1008" />
                  RESERVAR MI CUPO GRATIS
                  <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-1009" />
                </span>
                <span className="text-[10px] font-bold opacity-80 normal-case tracking-normal" data-id="element-1010">
                  Solo 100 cupos. Una vez lleno, se cierra el registro.
                </span>
              </span>
              <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine pointer-events-none" data-id="element-1011" />
            </button>
          </div>

          <p className="text-base md:text-lg lg:text-xl text-gray-300 leading-relaxed max-w-3xl mx-auto mb-8 md:mb-10 lg:mb-14" data-id="element-1012">
            Masterclass en vivo donde te muestro el{' '}
            <span className="text-white font-semibold" data-id="element-1013">modelo de negocio</span>{' '}
            que cientos de vendedores hispanos en USA están usando para
            reemplazar (y multiplicar) su sueldo del dealership —{' '}
            <span className="text-white font-semibold" data-id="element-1014">
              aplicando lo que ya sabes hacer.
            </span>
          </p>

          <div className="max-w-md lg:max-w-xl mx-auto" data-id="element-1015">
            <button type="button" onClick={() => setShowModal(true)} className="group relative w-full bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-base md:text-lg lg:text-xl uppercase tracking-tight rounded-2xl py-5 md:py-6 lg:py-7 px-6 shadow-[0_20px_60px_-15px_rgba(245,158,11,0.6)] hover:shadow-[0_20px_60px_-10px_rgba(245,158,11,0.75)] transition-all duration-300 transform hover:scale-[1.02] overflow-hidden hidden md:block" data-id="element-1016">
              <span className="relative z-10 flex flex-col items-center gap-1" data-id="element-1017">
                <span className="flex items-center justify-center gap-2.5 lg:gap-3" data-id="element-1018">
                  <Ticket className="w-5 h-5 md:w-6 md:h-6 lg:w-7 lg:h-7" data-id="element-1019" />
                  RESERVAR MI CUPO GRATIS
                  <ArrowRight className="w-5 h-5 md:w-6 md:h-6 lg:w-7 lg:h-7 transition-transform group-hover:translate-x-1" data-id="element-1020" />
                </span>
                <span className="text-[10px] md:text-xs font-bold opacity-80 normal-case tracking-normal" data-id="element-1021">
                  Solo 100 cupos. Una vez lleno, se cierra el registro.
                </span>
              </span>
              <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine pointer-events-none" data-id="element-1022" />
            </button>

            <div className="mt-5 lg:mt-6 grid grid-cols-2 lg:grid-cols-4 gap-2 lg:gap-2.5" data-id="element-1023">
              {['100% gratis', 'En vivo por Zoom', 'Q&A en directo', 'Regalo por asistir'].map(item => <div key={item} className="flex items-center justify-center lg:justify-start gap-1.5 bg-white/[0.03] border border-white/[0.06] rounded-full px-3 py-1.5" data-id="element-1024">
                  <CheckCircle2 className="w-3.5 h-3.5 text-emerald-400 flex-shrink-0" data-id="element-1025" />
                  <span className="text-[11px] md:text-xs text-gray-400 font-medium truncate" data-id="element-1026">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </section>

        {/* ============ SECTION 2 — Si Estás Leyendo Esto ============ */}
        <section className="mb-16 md:mb-20 lg:mb-28" data-id="element-1027">
          <div className="max-w-4xl mx-auto" data-id="element-1028">
            <div className="text-center mb-10 lg:mb-12" data-id="element-1029">
              <div className="inline-block text-amber-400 text-xs md:text-sm font-black uppercase tracking-[0.2em] mb-3" data-id="element-1030">
                Sé Por Qué Estás Aquí
              </div>
              <h2 className="text-2xl md:text-4xl lg:text-5xl font-black leading-tight" data-id="element-1031">
                Si Estás Leyendo Esto,{' '}
                <span className="text-amber-400" data-id="element-1032">Probablemente...</span>
              </h2>
            </div>

            <div className="space-y-5 text-gray-300 text-base md:text-lg lg:text-[19px] leading-relaxed max-w-3xl mx-auto" data-id="element-1033">
              <p data-id="element-1034">Llevas años vendiendo carros en el dealership.</p>
              <p data-id="element-1035">
                Eres bueno. Cumples cuotas. A veces top 5 del dealership. Otras
                veces te toca el mes malo.
              </p>
              <p className="text-white font-semibold" data-id="element-1036">
                Pero algo en ti dice "esto no es para siempre".
              </p>
              <p data-id="element-1037">Estás cansado de:</p>
            </div>

            <ul className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-3 lg:gap-4 max-w-4xl mx-auto" data-id="element-1038">
              {painPoints.map(p => <li key={p.text} className="flex items-start gap-3 bg-red-950/20 border border-red-500/15 rounded-xl px-4 py-3.5 lg:px-5 lg:py-4" data-id="element-1039">
                  <div className="w-9 h-9 rounded-xl bg-red-500/10 border border-red-500/30 flex items-center justify-center flex-shrink-0" data-id="element-1040">
                    <p.icon className="w-4 h-4 lg:w-[18px] lg:h-[18px] text-red-400" data-id="element-1041" />
                  </div>
                  <span className="text-sm md:text-base lg:text-[17px] text-gray-200 font-medium leading-snug" data-id="element-1042">
                    {p.text}
                  </span>
                </li>)}
            </ul>

            <p className="mt-10 text-center text-amber-400 text-lg md:text-xl lg:text-2xl font-black leading-tight max-w-2xl mx-auto" data-id="element-1043">
              Si te sientes identificado — esta masterclass es para ti.
            </p>
          </div>
        </section>

        {/* ============ SECTION 3 — Qué Vas A Ver EN VIVO ============ */}
        <section className="mb-16 md:mb-20 lg:mb-28" data-id="element-1044">
          <div className="text-center mb-10 md:mb-14 lg:mb-16" data-id="element-1045">
            <div className="inline-block text-amber-400 text-xs md:text-sm font-black uppercase tracking-[0.2em] mb-3" data-id="element-1046">
              La Agenda
            </div>
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-black leading-tight max-w-3xl mx-auto" data-id="element-1047">
              En 90 Minutos <span className="text-amber-400" data-id="element-1048">Vas A Ver:</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 lg:gap-6 max-w-5xl mx-auto" data-id="element-1049">
            {blocks.map((b, idx) => <div key={b.title} className="group relative bg-white/[0.025] border border-white/[0.08] rounded-2xl p-6 md:p-7 lg:p-8 hover:border-amber-500/40 hover:bg-white/[0.04] transition-all duration-300" data-id="element-1050">
                <div className="flex items-start gap-4" data-id="element-1051">
                  <div className="w-12 h-12 lg:w-14 lg:h-14 rounded-2xl bg-amber-500/10 border border-amber-500/30 flex items-center justify-center flex-shrink-0" data-id="element-1052">
                    <b.icon className="w-5 h-5 lg:w-6 lg:h-6 text-amber-400" data-id="element-1053" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-1054">
                    <div className="flex items-center gap-2 mb-2" data-id="element-1055">
                      <span className="text-amber-400 text-[10px] lg:text-xs font-black uppercase tracking-[0.18em]" data-id="element-1056">
                        {b.label}
                      </span>
                      <span className="w-1 h-1 rounded-full bg-amber-500/40" data-id="element-1057" />
                      <span className="text-gray-400 text-[10px] lg:text-xs font-bold uppercase tracking-wider" data-id="element-1058">
                        {b.tag}
                      </span>
                    </div>
                    <h3 className="text-base md:text-lg lg:text-xl font-black text-white mb-2 leading-snug" data-id="element-1059">
                      {b.title}
                    </h3>
                    <p className="text-sm md:text-[15px] lg:text-base text-gray-400 leading-relaxed" data-id="element-1060">
                      {b.desc}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="mt-10 lg:mt-12 max-w-md mx-auto" data-id="element-1061">
            <button type="button" onClick={() => setShowModal(true)} className="group w-full flex items-center justify-center gap-2.5 bg-white/[0.04] border border-amber-500/30 hover:bg-amber-500/10 hover:border-amber-400 text-white font-black text-sm md:text-base uppercase tracking-tight rounded-xl py-3.5 md:py-4 px-6 transition-all duration-300" data-id="element-1062">
              <Ticket className="w-4 h-4 md:w-5 md:h-5 text-amber-400" data-id="element-1063" />
              SÍ, QUIERO ASISTIR AL WEBINAR
              <ArrowRight className="w-4 h-4 md:w-5 md:h-5 text-amber-400 transition-transform group-hover:translate-x-1" data-id="element-1064" />
            </button>
          </div>
        </section>

        {/* ============ SECTION 4 — Caso Real Andrés ============ */}
        <section className="mb-16 md:mb-20 lg:mb-28" data-id="element-1065">
          <div className="max-w-5xl mx-auto" data-id="element-1066">
            <div className="text-center mb-10 lg:mb-12" data-id="element-1067">
              <div className="inline-block text-amber-400 text-xs md:text-sm font-black uppercase tracking-[0.2em] mb-3" data-id="element-1068">
                Caso Real
              </div>
              <h2 className="text-2xl md:text-4xl lg:text-5xl font-black leading-[1.1] max-w-4xl mx-auto" data-id="element-1069">
                Andrés Era Vendedor De Toyota En Phoenix. Hoy Gana{' '}
                <span className="text-amber-400" data-id="element-1070">$18K/Mes</span> Desde Casa.
              </h2>
            </div>

            <div className="bg-gradient-to-br from-amber-950/20 to-[#0a1428] border border-amber-500/20 rounded-3xl p-6 md:p-10 lg:p-12" data-id="element-1071">
              <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12 mb-10 lg:mb-12" data-id="element-1072">
                <div className="lg:col-span-3 space-y-4 text-gray-300 text-base lg:text-lg leading-relaxed" data-id="element-1073">
                  <p data-id="element-1074">
                    Andrés tiene 38 años. 8 años vendiendo carros en Toyota
                    Phoenix. Top 5 del dealership casi siempre.
                  </p>
                  <p data-id="element-1075">
                    Pero llegaba a casa a las 9:30 PM. Sus hijos crecían sin él.
                    Su esposa Laura le dijo que Sebastián (12 años) le había
                    preguntado si su papá era{' '}
                    <span className="text-white font-semibold" data-id="element-1076">"real"</span> o
                    solo aparecía para Navidad.
                  </p>
                  <p className="text-white font-semibold" data-id="element-1077">
                    Esa noche, Andrés no durmió.
                  </p>
                  <p data-id="element-1078">
                    A las 3 AM estaba en su laptop buscando alternativas.
                    Encontró uno de mis webinars.
                  </p>
                </div>

                {/* Pull quote */}
                <div className="lg:col-span-2 relative bg-white/[0.04] border border-amber-500/30 rounded-2xl p-6 lg:p-7" data-id="element-1079">
                  <Quote className="w-7 h-7 text-amber-400/60 mb-3" data-id="element-1080" />
                  <p className="text-white text-base lg:text-lg font-medium italic leading-snug mb-4" data-id="element-1081">
                    "Lo único que me detenía antes era no saber CÓMO. El día que
                    vi este webinar, dejé de tener excusa."
                  </p>
                  <div className="flex items-center gap-2.5" data-id="element-1082">
                    <div className="w-9 h-9 rounded-full bg-amber-500/15 border border-amber-500/30 flex items-center justify-center" data-id="element-1083">
                      <User className="w-4 h-4 text-amber-400" data-id="element-1084" />
                    </div>
                    <div data-id="element-1085">
                      <div className="text-white font-black text-sm" data-id="element-1086">
                        Andrés
                      </div>
                      <div className="text-gray-400 text-[11px] uppercase tracking-wider font-bold" data-id="element-1087">
                        Ex-vendedor Toyota Phoenix
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Milestones timeline */}
              <div data-id="element-1088">
                <div className="text-amber-400 text-xs lg:text-sm font-black uppercase tracking-[0.2em] mb-5" data-id="element-1089">
                  Los Resultados
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 lg:gap-4" data-id="element-1090">
                  {milestones.map(m => <div key={m.mes} className={`relative rounded-2xl p-4 lg:p-5 border transition-all ${m.highlight ? 'bg-amber-500/10 border-amber-500/50 shadow-[0_0_30px_rgba(245,158,11,0.15)]' : 'bg-white/[0.03] border-white/[0.08]'}`} data-id="element-1091">
                      <div className={`text-[10px] lg:text-xs font-black uppercase tracking-[0.18em] mb-1.5 ${m.highlight ? 'text-amber-400' : 'text-gray-400'}`} data-id="element-1092">
                        {m.mes}
                      </div>
                      <div className={`text-lg lg:text-2xl font-black mb-1 ${m.highlight ? 'text-amber-400' : 'text-white'}`} data-id="element-1093">
                        {m.value}
                      </div>
                      <div className="text-[11px] lg:text-xs text-gray-400 leading-snug" data-id="element-1094">
                        {m.note}
                      </div>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ============ SECTION 5 — Detalles + Countdown ============ */}
        <section className="mb-16 md:mb-20 lg:mb-28" data-id="element-1095">
          <div className="max-w-4xl mx-auto" data-id="element-1096">
            <div className="text-center mb-10 lg:mb-12" data-id="element-1097">
              <div className="inline-block text-amber-400 text-xs md:text-sm font-black uppercase tracking-[0.2em] mb-3" data-id="element-1098">
                Reserva Tu Cupo
              </div>
              <h2 className="text-2xl md:text-4xl lg:text-5xl font-black leading-tight" data-id="element-1099">
                Los <span className="text-amber-400" data-id="element-1100">Detalles</span>:
              </h2>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 lg:gap-6 mb-8 lg:mb-10" data-id="element-1101">
              {[{
              icon: Calendar,
              label: 'Fecha',
              value: thursdayLabel
            }, {
              icon: Clock,
              label: 'Hora',
              value: '7:00 PM hora Miami (EST)'
            }, {
              icon: Video,
              label: 'Duración',
              value: '90 min + 30 min Q&A'
            }, {
              icon: Monitor,
              label: 'Plataforma',
              value: 'Zoom'
            }, {
              icon: DollarSign,
              label: 'Inversión',
              value: '100% GRATIS',
              highlight: true
            }, {
              icon: AlertTriangle,
              label: 'Importante',
              value: 'Es EN VIVO — NO hay reposición',
              warning: true
            }].map(d => <div key={d.label} className={`flex items-start gap-3 rounded-2xl p-5 lg:p-6 border ${d.warning ? 'bg-red-950/20 border-red-500/30' : d.highlight ? 'bg-amber-500/10 border-amber-500/40 shadow-[0_0_30px_rgba(245,158,11,0.12)]' : 'bg-white/[0.03] border-white/[0.08]'}`} data-id="element-1102">
                  <div className={`w-11 h-11 lg:w-12 lg:h-12 rounded-xl flex items-center justify-center flex-shrink-0 border ${d.warning ? 'bg-red-500/10 border-red-500/30' : 'bg-amber-500/10 border-amber-500/30'}`} data-id="element-1103">
                    <d.icon className={`w-5 h-5 ${d.warning ? 'text-red-400' : 'text-amber-400'}`} data-id="element-1104" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-1105">
                    <div className="text-[10px] lg:text-xs font-black uppercase tracking-[0.18em] text-gray-400 mb-1" data-id="element-1106">
                      {d.label}
                    </div>
                    <div className={`font-black text-base lg:text-lg ${d.warning ? 'text-red-400' : d.highlight ? 'text-amber-400' : 'text-white'}`} data-id="element-1107">
                      {d.value}
                    </div>
                  </div>
                </div>)}
            </div>

            {/* Countdown */}
            <div className="relative bg-gradient-to-br from-[#0f1b35] to-[#0a1428] border-2 border-amber-500/40 rounded-3xl p-6 md:p-10 lg:p-12 text-center shadow-[0_0_60px_rgba(245,158,11,0.15)] overflow-hidden" data-id="element-1108">
              <div className="absolute top-0 right-0 w-40 h-40 bg-amber-400/10 blur-3xl rounded-full" data-id="element-1109" />
              <div className="relative" data-id="element-1110">
                <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/30 rounded-full px-4 py-1.5 mb-5" data-id="element-1111">
                  <Clock className="w-3.5 h-3.5 text-amber-400 animate-pulse" data-id="element-1112" />
                  <span className="text-amber-400 text-[11px] md:text-xs font-black uppercase tracking-widest" data-id="element-1113">
                    El Webinar Empieza En
                  </span>
                </div>

                <div className="grid grid-cols-4 gap-2 md:gap-4 max-w-2xl mx-auto mb-7" data-id="element-1114">
                  {[{
                  label: 'Días',
                  value: countdown.days
                }, {
                  label: 'Horas',
                  value: countdown.hours
                }, {
                  label: 'Min',
                  value: countdown.minutes
                }, {
                  label: 'Seg',
                  value: countdown.seconds
                }].map(u => <div key={u.label} className="bg-[#0a1428] border border-amber-500/20 rounded-xl py-4 md:py-6 px-2 md:px-4" data-id="element-1115">
                      <div className="text-3xl md:text-5xl lg:text-6xl font-black text-amber-400 tabular-nums leading-none mb-1.5" data-id="element-1116">
                        {String(u.value).padStart(2, '0')}
                      </div>
                      <div className="text-[9px] md:text-[10px] lg:text-xs text-gray-400 uppercase tracking-[0.18em] font-bold" data-id="element-1117">
                        {u.label}
                      </div>
                    </div>)}
                </div>

                <button type="button" onClick={() => setShowModal(true)} className="group relative w-full max-w-md mx-auto bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-base md:text-lg uppercase tracking-tight rounded-2xl py-5 md:py-6 px-6 shadow-[0_20px_60px_-15px_rgba(245,158,11,0.6)] transition-all duration-300 transform hover:scale-[1.02] overflow-hidden flex" data-id="element-1118">
                  <span className="relative z-10 flex items-center justify-center gap-2.5 w-full" data-id="element-1119">
                    <Ticket className="w-5 h-5 md:w-6 md:h-6" data-id="element-1120" />
                    RESERVAR MI CUPO AHORA
                    <ArrowRight className="w-5 h-5 md:w-6 md:h-6 transition-transform group-hover:translate-x-1" data-id="element-1121" />
                  </span>
                  <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine pointer-events-none" data-id="element-1122" />
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* ============ SECTION 6 — NO Es Para Todos ============ */}
        <section className="mb-16 md:mb-20 lg:mb-28" data-id="element-1123">
          <div className="max-w-5xl mx-auto" data-id="element-1124">
            <div className="text-center mb-10 lg:mb-12" data-id="element-1125">
              <div className="inline-block text-amber-400 text-xs md:text-sm font-black uppercase tracking-[0.2em] mb-3" data-id="element-1126">
                Brutalmente Honesto
              </div>
              <h2 className="text-2xl md:text-4xl lg:text-5xl font-black leading-tight max-w-3xl mx-auto" data-id="element-1127">
                Importante: Este Webinar{' '}
                <span className="text-amber-400" data-id="element-1128">NO Es Para Todos</span>
              </h2>
            </div>

            <div className="space-y-4 mb-10 max-w-3xl mx-auto text-gray-300 text-base md:text-lg leading-relaxed text-center" data-id="element-1129">
              <p data-id="element-1130">
                Antes de que te registres, te quiero ser brutalmente honesto.
              </p>
              <p className="text-white font-semibold" data-id="element-1131">
                Prefiero que te bajes ahora si no encajas, que perder 2 horas de
                tu tiempo (y del mío).
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 lg:gap-6" data-id="element-1132">
              {/* Es para ti si */}
              <div className="bg-gradient-to-br from-amber-950/20 to-[#0a1428] border border-amber-500/30 rounded-2xl p-6 lg:p-8 shadow-[0_0_40px_rgba(245,158,11,0.1)]" data-id="element-1133">
                <div className="flex items-center gap-2.5 mb-5 lg:mb-6" data-id="element-1134">
                  <div className="w-10 h-10 rounded-xl bg-amber-500/10 border border-amber-500/30 flex items-center justify-center" data-id="element-1135">
                    <Sparkles className="w-4 h-4 text-amber-400" data-id="element-1136" />
                  </div>
                  <span className="text-amber-400 text-xs lg:text-sm font-black uppercase tracking-widest" data-id="element-1137">
                    Es Para Ti Si...
                  </span>
                </div>
                <ul className="space-y-3 lg:space-y-3.5" data-id="element-1138">
                  {isFor.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-1139">
                      <CheckCircle2 className="w-4 h-4 lg:w-5 lg:h-5 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-1140" />
                      <span className="text-sm md:text-base lg:text-[17px] text-gray-200 leading-snug" data-id="element-1141">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>

              {/* No es para ti si */}
              <div className="bg-gradient-to-br from-red-950/20 to-[#0a1428] border border-red-500/20 rounded-2xl p-6 lg:p-8" data-id="element-1142">
                <div className="flex items-center gap-2.5 mb-5 lg:mb-6" data-id="element-1143">
                  <div className="w-10 h-10 rounded-xl bg-red-500/10 border border-red-500/30 flex items-center justify-center" data-id="element-1144">
                    <XCircle className="w-4 h-4 text-red-400" data-id="element-1145" />
                  </div>
                  <span className="text-red-400 text-xs lg:text-sm font-black uppercase tracking-widest" data-id="element-1146">
                    No Es Para Ti Si...
                  </span>
                </div>
                <ul className="space-y-3 lg:space-y-3.5" data-id="element-1147">
                  {notFor.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-1148">
                      <X className="w-4 h-4 lg:w-5 lg:h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-1149" />
                      <span className="text-sm md:text-base lg:text-[17px] text-gray-300 leading-snug" data-id="element-1150">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* ============ SECTION 7 — FAQ ============ */}
        <section className="mb-16 md:mb-20 lg:mb-28" data-id="element-1151">
          <div className="max-w-3xl mx-auto" data-id="element-1152">
            <div className="text-center mb-10 lg:mb-12" data-id="element-1153">
              <div className="inline-block text-amber-400 text-xs md:text-sm font-black uppercase tracking-[0.2em] mb-3" data-id="element-1154">
                FAQ
              </div>
              <h2 className="text-2xl md:text-4xl lg:text-5xl font-black leading-tight" data-id="element-1155">
                Preguntas Que{' '}
                <span className="text-amber-400" data-id="element-1156">Probablemente Tienes</span>
              </h2>
            </div>

            <div className="space-y-3 lg:space-y-4" data-id="element-1157">
              {faqs.map((f, idx) => <div key={f.q} className={`bg-white/[0.025] border rounded-2xl overflow-hidden transition-colors ${openFaq === idx ? 'border-amber-500/40' : 'border-white/[0.08]'}`} data-id="element-1158">
                  <button type="button" onClick={() => setOpenFaq(openFaq === idx ? null : idx)} className="w-full flex items-center gap-3 lg:gap-4 px-5 py-4 lg:px-7 lg:py-5 text-left hover:bg-white/[0.015] transition-colors" data-id="element-1159">
                    <div className={`w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors ${openFaq === idx ? 'bg-amber-500/15 border border-amber-500/40' : 'bg-white/[0.04] border border-white/[0.08]'}`} data-id="element-1160">
                      <HelpCircle className={`w-4 h-4 lg:w-[18px] lg:h-[18px] ${openFaq === idx ? 'text-amber-400' : 'text-gray-400'}`} data-id="element-1161" />
                    </div>
                    <span className="flex-1 text-white font-bold text-sm md:text-base lg:text-lg leading-snug" data-id="element-1162">
                      {f.q}
                    </span>
                    <ArrowRight className={`w-4 h-4 lg:w-5 lg:h-5 text-gray-500 transition-transform flex-shrink-0 ${openFaq === idx ? 'rotate-90 text-amber-400' : ''}`} data-id="element-1163" />
                  </button>
                  {openFaq === idx && <div className="px-5 pb-5 lg:px-7 lg:pb-6 pl-[68px] lg:pl-[92px] text-gray-300 text-sm md:text-base lg:text-[17px] leading-relaxed" data-id="element-1164">
                      {f.a}
                    </div>}
                </div>)}
            </div>
          </div>
        </section>

        {/* ============ SECTION 8 — FINAL CTA ============ */}
        <section className="mb-8" data-id="element-1165">
          <div className="max-w-3xl mx-auto" data-id="element-1166">
            <div className="text-center mb-8 lg:mb-10" data-id="element-1167">
              <div className="inline-block text-amber-400 text-xs md:text-sm font-black uppercase tracking-[0.2em] mb-3" data-id="element-1168">
                Una Última Cosa
              </div>
              <h2 className="text-2xl md:text-4xl lg:text-5xl font-black leading-tight" data-id="element-1169">
                Una Última Cosa Antes De Que{' '}
                <span className="text-amber-400" data-id="element-1170">Te Vayas...</span>
              </h2>
            </div>

            <div className="space-y-4 mb-10 text-gray-300 text-base md:text-lg lg:text-[19px] leading-relaxed max-w-2xl mx-auto" data-id="element-1171">
              <p data-id="element-1172">Llegaste hasta el final de esta página.</p>
              <p data-id="element-1173">
                Eso me dice algo importante: algo en ti dice{' '}
                <span className="text-white font-semibold" data-id="element-1174">"quiero más"</span>.
              </p>
              <p data-id="element-1175">
                La mayoría de los vendedores que aterrizan aquí NO se registran.
                Solo "miran". Se quedan pensando.
              </p>
              <p data-id="element-1176">Y siguen con su vida en el dealership.</p>
              <p className="text-white font-semibold" data-id="element-1177">
                Tú, que llegaste aquí, eres diferente. Y ahora solo te queda UNA
                decisión:
              </p>
            </div>

            <div className="relative bg-gradient-to-br from-[#0f1b35] to-[#0a1428] border-2 border-amber-500/40 rounded-3xl p-6 md:p-10 lg:p-12 shadow-[0_0_60px_rgba(245,158,11,0.15)] overflow-hidden" data-id="element-1178">
              <div className="absolute -inset-2 bg-amber-400/20 blur-3xl rounded-3xl pointer-events-none" data-id="element-1179" />
              <div className="relative" data-id="element-1180">
                <div className="text-center mb-8" data-id="element-1181">
                  <Quote className="w-8 h-8 text-amber-400/40 mx-auto mb-4" data-id="element-1182" />
                  <p className="text-xl md:text-2xl lg:text-3xl font-black text-white leading-snug mb-3 max-w-xl mx-auto" data-id="element-1183">
                    ¿El jueves a las 7 PM vas a estar viendo la Masterclass
                    conmigo?
                  </p>
                  <p className="text-gray-400 text-base lg:text-lg italic" data-id="element-1184">
                    O vas a estar haciendo otra cosa que ya hiciste 1,000 veces.
                    <br data-id="element-1185" />
                    <span className="text-amber-400 font-bold not-italic" data-id="element-1186">
                      Tu decisión.
                    </span>
                  </p>
                </div>

                {/* Inline Registration Form */}
                <div className="max-w-md mx-auto bg-[#0a1428]/60 border border-amber-500/25 rounded-2xl p-5 md:p-6 backdrop-blur-sm" data-id="element-1187">
                  <div className="text-center mb-5" data-id="element-1188">
                    <div className="inline-flex items-center justify-center w-12 h-12 bg-amber-500/10 border border-amber-500/30 rounded-2xl mb-3" data-id="element-1189">
                      <Ticket className="w-5 h-5 text-amber-400" data-id="element-1190" />
                    </div>
                    <h3 className="text-lg md:text-xl font-black text-white uppercase tracking-tight mb-1" data-id="element-1191">
                      Reserva Tu Cupo Gratis
                    </h3>
                    <p className="text-gray-400 text-xs md:text-sm" data-id="element-1192">
                      Masterclass EN VIVO — {thursdayLabel} · 7PM Miami
                    </p>
                  </div>

                  <form onSubmit={handleSubmit} className="space-y-3" data-id="element-1193">
                    <div className="relative" data-id="element-1194">
                      <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-1195">
                        <User className="h-4 w-4 text-gray-500" data-id="element-1196" />
                      </div>
                      <input ref={nameRef} type="text" name="name" value={name} onChange={e => setName(e.target.value)} placeholder="Tu nombre completo" required minLength={2} autoComplete="name" className="w-full pl-11 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white text-sm placeholder-gray-500 focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all" data-id="element-1197" />
                    </div>

                    <div className="relative" data-id="element-1198">
                      <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-1199">
                        <Mail className="h-4 w-4 text-gray-500" data-id="element-1200" />
                      </div>
                      <input ref={emailRef} type="email" name="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Tu mejor email" required autoComplete="email" className="w-full pl-11 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white text-sm placeholder-gray-500 focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all" data-id="element-1201" />
                    </div>

                    <div className="flex gap-2" data-id="element-1202">
                      <div className="relative w-[38%]" data-id="element-1203">
                        <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none" data-id="element-1204">
                          <Globe className="h-3.5 w-3.5 text-gray-500" data-id="element-1205" />
                        </div>
                        <select name="areaCode" value={areaCode} onChange={e => setAreaCode(e.target.value)} className="w-full pl-7 pr-1 py-3 rounded-xl bg-white/5 border border-white/10 text-white text-xs focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all appearance-none" data-id="element-1206">
                          {COUNTRY_CODES.map(c => <option key={c.code} value={c.code} className="bg-gray-900" data-id="element-1207">
                              {c.code} {c.country}
                            </option>)}
                        </select>
                      </div>
                      <div className="relative w-[62%]" data-id="element-1208">
                        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-1209">
                          <Phone className="h-4 w-4 text-gray-500" data-id="element-1210" />
                        </div>
                        <input ref={phoneRef} type="tel" name="phone" value={phone} onChange={e => setPhone(e.target.value.replace(/\D/g, ''))} placeholder="WhatsApp (opcional)" autoComplete="tel" className="w-full pl-11 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white text-sm placeholder-gray-500 focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all" data-id="element-1211" />
                      </div>
                    </div>

                    <label className="flex items-start gap-2.5 cursor-pointer group pt-1" data-id="element-1212">
                      <div className="relative flex-shrink-0 mt-0.5" data-id="element-1213">
                        <input type="checkbox" checked={smsConsent} onChange={e => setSmsConsent(e.target.checked)} className="sr-only peer" data-id="element-1214" />
                        <div className="w-4 h-4 border-2 border-gray-500 rounded bg-white/5 peer-checked:bg-amber-400 peer-checked:border-amber-400 transition-all flex items-center justify-center" data-id="element-1215">
                          {smsConsent && <CheckCircle2 className="w-3 h-3 text-[#0a1428]" strokeWidth={3} data-id="element-1216" />}
                        </div>
                      </div>
                      <span className="text-[10px] md:text-[11px] text-gray-400 leading-snug" data-id="element-1217">
                        Acepto recibir SMS con recordatorios del webinar.
                        Responde STOP para cancelar.
                      </span>
                    </label>

                    <button type="submit" disabled={isSubmitting} className="group relative w-full bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-sm md:text-base uppercase tracking-tight rounded-xl py-4 px-6 shadow-[0_0_30px_rgba(245,158,11,0.4)] transition-all duration-300 transform hover:scale-[1.01] disabled:opacity-60 disabled:cursor-not-allowed overflow-hidden mt-1" data-id="element-1218">
                      <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-1219">
                        {isSubmitting ? <>Reservando...</> : <>
                            <Ticket className="w-4 h-4 md:w-5 md:h-5" data-id="element-1220" />
                            RESERVAR MI CUPO AHORA
                            <ArrowRight className="w-4 h-4 md:w-5 md:h-5 transition-transform group-hover:translate-x-1" data-id="element-1221" />
                          </>}
                      </span>
                      <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine pointer-events-none" data-id="element-1222" />
                    </button>

                    <div className="flex items-center justify-center gap-1.5 text-[10px] md:text-xs text-gray-500 pt-1" data-id="element-1223">
                      <Lock className="w-3 h-3" data-id="element-1224" />
                      Tu información está 100% segura
                    </div>
                  </form>
                </div>

                <div className="mt-6 flex items-center justify-center gap-x-5 gap-y-2 flex-wrap text-xs md:text-sm text-gray-400" data-id="element-1225">
                  <span className="flex items-center gap-1.5" data-id="element-1226">
                    <Calendar className="w-3.5 h-3.5 text-emerald-400" data-id="element-1227" />
                    {thursdayLabel} · 7PM EST
                  </span>
                  <span className="flex items-center gap-1.5" data-id="element-1228">
                    <ShieldCheck className="w-3.5 h-3.5 text-emerald-400" data-id="element-1229" />
                    Sin costo
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-1230" />

      {/* Registration Modal */}
      {showModal && <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 backdrop-blur-sm" onClick={() => setShowModal(false)} data-id="element-1231">
          <div className="bg-[#0f1b35] border border-amber-500/30 rounded-2xl max-w-md w-full p-6 md:p-8 relative shadow-[0_0_50px_rgba(245,158,11,0.2)] max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-1232">
            <button onClick={() => setShowModal(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors p-1" aria-label="Cerrar" data-id="element-1233">
              <X className="w-6 h-6" data-id="element-1234" />
            </button>

            <div className="text-center mb-6" data-id="element-1235">
              <div className="inline-flex items-center justify-center w-14 h-14 bg-amber-500/10 border border-amber-500/30 rounded-2xl mb-3" data-id="element-1236">
                <Ticket className="w-6 h-6 text-amber-400" data-id="element-1237" />
              </div>
              <h2 className="text-2xl md:text-3xl font-black text-white mb-2 uppercase tracking-tight" data-id="element-1238">
                Reservar Mi Cupo
              </h2>
              <p className="text-gray-400 text-sm" data-id="element-1239">
                Masterclass EN VIVO — Este {thursdayLabel} 7PM Miami
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1240">
              <div className="space-y-1" data-id="element-1241">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-1242">
                  Nombre Completo
                </label>
                <div className="relative" data-id="element-1243">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-1244">
                    <User className="h-5 w-5 text-gray-500" data-id="element-1245" />
                  </div>
                  <input ref={nameRef} type="text" name="name" value={name} onChange={e => setName(e.target.value)} placeholder="Tu nombre" required minLength={2} autoComplete="name" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all" data-id="element-1246" />
                </div>
              </div>

              <div className="space-y-1" data-id="element-1247">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-1248">
                  Tu Mejor Email
                </label>
                <div className="relative" data-id="element-1249">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-1250">
                    <Mail className="h-5 w-5 text-gray-500" data-id="element-1251" />
                  </div>
                  <input ref={emailRef} type="email" name="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="ejemplo@correo.com" required autoComplete="email" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all" data-id="element-1252" />
                </div>
              </div>

              <div className="space-y-1" data-id="element-1253">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-1254">
                  WhatsApp (Para Recordatorios)
                </label>
                <div className="flex gap-2" data-id="element-1255">
                  <div className="relative w-1/3" data-id="element-1256">
                    <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none" data-id="element-1257">
                      <Globe className="h-4 w-4 text-gray-500" data-id="element-1258" />
                    </div>
                    <select name="areaCode" value={areaCode} onChange={e => setAreaCode(e.target.value)} className="w-full pl-8 pr-2 py-3 rounded-xl bg-white/5 border border-white/10 text-white focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all appearance-none text-sm" data-id="element-1259">
                      {COUNTRY_CODES.map(c => <option key={c.code} value={c.code} className="bg-gray-900" data-id="element-1260">
                          {c.code} {c.country}
                        </option>)}
                    </select>
                  </div>

                  <div className="relative w-2/3" data-id="element-1261">
                    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-1262">
                      <Phone className="h-5 w-5 text-gray-500" data-id="element-1263" />
                    </div>
                    <input ref={phoneRef} type="tel" name="phone" value={phone} onChange={e => setPhone(e.target.value.replace(/\D/g, ''))} placeholder="Número" required minLength={7} autoComplete="tel" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all" data-id="element-1264" />
                  </div>
                </div>
              </div>

              <label className="flex items-start gap-3 cursor-pointer group pt-1" data-id="element-1265">
                <div className="relative flex-shrink-0 mt-0.5" data-id="element-1266">
                  <input type="checkbox" checked={smsConsent} onChange={e => setSmsConsent(e.target.checked)} className="sr-only peer" data-id="element-1267" />
                  <div className="w-5 h-5 border-2 border-gray-500 rounded bg-white/5 peer-checked:bg-amber-400 peer-checked:border-amber-400 transition-all flex items-center justify-center" data-id="element-1268">
                    {smsConsent && <CheckCircle2 className="w-3.5 h-3.5 text-[#0a1428]" strokeWidth={3} data-id="element-1269" />}
                  </div>
                </div>
                <span className="text-[11px] md:text-xs text-gray-400 leading-relaxed" data-id="element-1270">
                  Acepto recibir mensajes SMS con recordatorios e información
                  del webinar. Puedo cancelar en cualquier momento respondiendo
                  STOP.
                </span>
              </label>

              <button type="submit" disabled={isSubmitting} className="group relative w-full bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-base md:text-lg uppercase tracking-tight rounded-xl py-4 px-6 shadow-[0_0_30px_rgba(245,158,11,0.4)] transition-all duration-300 transform hover:scale-[1.01] disabled:opacity-60 disabled:cursor-not-allowed overflow-hidden" data-id="element-1271">
                <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-1272">
                  {isSubmitting ? <>Reservando...</> : <>
                      <Ticket className="w-5 h-5" data-id="element-1273" />
                      RESERVAR MI CUPO AHORA
                      <ArrowRight className="w-5 h-5" data-id="element-1274" />
                    </>}
                </span>
              </button>

              <div className="flex items-center justify-center gap-1.5 text-xs text-gray-500" data-id="element-1275">
                <Lock className="w-3 h-3" data-id="element-1276" />
                Tu información está 100% segura
              </div>
            </form>
          </div>
        </div>}
    </div>;
}